import React, { FC } from 'react';
import { Text } from '@mofid-securities/uikit';

export const EmptyState: FC = () => {
  return (
    <Text
      className="text-gray-filled-secondary-enabled"
      size={'xxs'}
      weight={'regular'}
    >
      در دوره‌های زمانی مشخص، به صورت خودکار و بی‌نیاز از مراجعه مجدد به
      اپلیکیشن و بدون نگرانی از فراموشی، سرمایه‌گذاری نمایید.
    </Text>
  );
};
